import React, { useState } from "react";
import MuiCheckbox from "./checkbox/MuiCheckbox";
import "../components/checkbox/muiCheckbox.scss";

const insertLabel = [
  {
    displayName: "Use RevoFit®",
  },
];

const Revofit = ({
  setActiveInnerStep,
  labelOnChange,
  checkBoxesOption,
  value,
  LanyardLabelOption,
  revoChange,
  revoLockChange,
  lanyardLabelDefaultValue,
  revoFitDefaultValue,
  revoOptionDefaultValue,
}) => {
  console.log(revoFitDefaultValue);
  const [showRevo, setShowRevo] = useState(revoFitDefaultValue);

  const handleChange = (e) => {
    setShowRevo((prevShowRevo) => !prevShowRevo);
    setActiveInnerStep(4);
    if (labelOnChange) {
      labelOnChange(e);
    }
  };

  return (
    <div className="muiCheckbox">
      <MuiCheckbox
        checkboxes={insertLabel}
        boxLabel="RevoFit®"
        onChange={handleChange}
        defaultChecked={revoFitDefaultValue}
        value={value}
      />

      {showRevo && (
        <>
          <div style={{ marginTop: "-22px" }}>
            <MuiCheckbox
              checkboxes={checkBoxesOption}
              onChange={revoChange}
              defaultValue={revoOptionDefaultValue}
            />
          </div>

          <MuiCheckbox
            checkboxes={LanyardLabelOption}
            boxLabel="RevoLock® Lanyard"
            onChange={revoLockChange}
            defaultValue={lanyardLabelDefaultValue}
          />
        </>
      )}
    </div>
  );
};

export default Revofit;
